import { createAsyncThunk } from '@reduxjs/toolkit'
import { ShipmentData } from 'redux/slices/packages-slice'
import nestApiService from 'services/api/nest-api-service'
import { apiErrorBody } from 'utils/apiError'
import { filterQueryParams } from 'utils/filterQueryParams'

export interface FetchShipmentDataParams {
  zipCode: string
  isCpdf?: boolean
  isSexShop?: boolean
}

export const fetchShipmentData = createAsyncThunk(
  'fetch-shipment-data',
  async ({ zipCode, isCpdf, isSexShop }: FetchShipmentDataParams, { rejectWithValue }) => {
    try {
      const { data } = await nestApiService.apiInstance.get<ShipmentData[]>('correios', {
        params: filterQueryParams({
          zipCode,
          isCpdf,
          isSexShop
        })
      })
      return data
    } catch (error: any) {
      return rejectWithValue(apiErrorBody(error)?.message)
    }
  }
)
